import { consentKey } from "./consent/consentHandler";
export function googleAnalyticsScript() {
    let consentStateString = localStorage.getItem(consentKey);
    let consentState = consentStateString ? JSON.parse(consentStateString) : null;
    let enableAnalytics = consentState && (consentState === null || consentState === void 0 ? void 0 : consentState.details.pixel);
    if (enableAnalytics) {
        let gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-TTXEKDB6N4";
        document.head.appendChild(gtagScript);
        let gtagConfigScript = document.createElement('script');
        let gtagConfigScriptContent = "window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('consent', 'default', { ad_user_data: 'granted', ad_personalization: 'granted', ad_storage: 'granted', analytics_storage: 'granted' }); gtag('js', new Date()); gtag('config', 'G-TTXEKDB6N4');";
        gtagConfigScript.innerHTML = gtagConfigScriptContent;
        document.head.appendChild(gtagConfigScript);
        let gtmScript = document.createElement('script');
        let gtmScriptContent = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-W76HC77');";
        gtmScript.innerHTML = gtmScriptContent;
        document.head.appendChild(gtmScript);
    }
}
